<template>
  <div class="body_content">
    <div class="body_center">
      <dl class="panel_title">
        <dt><img src="./img/icon_football.png" /></dt>
        <dd>竞猜排行榜规则</dd>
        <dt><img src="./img/icon_football.png" /></dt>
      </dl>
      <div class="guess_role">
        <p>1.时间为周一0点开始至当周周日24点结束，下周零点自动刷新新的排名。</p>
        <p>
          2.当周在解说直播间参与竞猜(鹰选)活动，用鹰钻进行竞猜(鹰选)，投注结果正确与否，最终结果与投注内容一致，按照对应赔率获得鹰钻。排行榜统计本周各个用户竞猜获胜的鹰钻数量，排位名称按照数量由高到低降序排名。
        </p>
        <p>3.为保障活动长久公平，以净盈利为统计规则。</p>
        <p>4.对于赔率错误，赔率不合理的竞猜(鹰选)，会清除盈利，退回投注鹰钻。</p>
        <p>5.奖品发放请获奖用户凭个人中心截图和中奖名单截图联系在线客服，客服会安排奖品发放。</p>
        <p>6.最终解释权归于猎鹰直播。</p>
      </div>

      <dl class="panel_title" style="width: 2rem; margin-top: 0.5rem">
        <dt><img src="./img/icon_football.png" /></dt>
        <dd>竞猜奖品区</dd>
        <dt><img src="./img/icon_football.png" /></dt>
      </dl>
      <ul class="prize_products">
        <li>
          <div class="cover">
            <img src="./img/pro1.png" />
          </div>
          <dl class="product_title">
            <dt>第一名：</dt>
            <dd>竞猜达人榜第一名用户奖励<br />苹果手表s8 iwatch</dd>
          </dl>
        </li>

        <li>
          <div class="cover">
            <img src="./img/pro2.png" />
          </div>
          <dl class="product_title">
            <dt>第二名：</dt>
            <dd>竞猜达人榜第二名用户奖励<br />AirPods苹果无线蓝牙耳机</dd>
          </dl>
        </li>

        <li>
          <div class="cover">
            <img src="./img/pro3.png" />
          </div>
          <dl class="product_title">
            <dt>第三名：</dt>
            <dd>竞猜达人榜第三名用户奖励<br />卡西欧手表</dd>
          </dl>
        </li>

        <li>
          <div class="cover">
            <img src="./img/pro300.png" />
          </div>
          <dl class="product_title">
            <dt>第四至八名：</dt>
            <dd>竞猜达人榜第四至八名用户<br />奖励300元现金</dd>
          </dl>
        </li>

        <li>
          <div class="cover">
            <img src="./img/pro200.png" />
          </div>
          <dl class="product_title">
            <dt>第九至十三名：</dt>
            <dd>竞猜达人榜第九至十三名用户<br />奖励200元现金</dd>
          </dl>
        </li>

        <li>
          <div class="cover">
            <img src="./img/pro100.png" />
          </div>
          <dl class="product_title">
            <dt>第十四至二十名：</dt>
            <dd>竞猜达人榜第十四至二十名用户<br />奖励100元现金</dd>
          </dl>
        </li>
      </ul>

      <dl class="panel_title" style="width: 1.8rem; margin-top: 0.5rem">
        <dt><img src="./img/icon_football.png" /></dt>
        <dd>参与步骤</dd>
        <dt><img src="./img/icon_football.png" /></dt>
      </dl>
      <ul class="join_step">
        <li style="width: 4.1rem">
          <div class="step_text">第一步</div>
          <p>直播列表内带有‘竞猜’标示的直播间，点击进入直播间</p>
          <div class="step_img">
            <img src="./img/step1.png" />
          </div>
        </li>
        <li style="width: 5.15rem">
          <div class="step_text">第二步</div>
          <p>直播间播放器左下角点击‘<img src="./img/step2_text.png" />’参与竞猜</p>
          <div class="step_img">
            <img src="./img/step2.png" />
          </div>
        </li>
        <li style="width: 3rem">
          <div class="step_text">第三步</div>
          <p>竞猜记录可在我的页面-鹰选历史内查看</p>
          <div class="step_img" style="width: 2.7rem">
            <img src="./img/step3.png" />
          </div>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
import { mapState, mapMutations } from "vuex";
import { post } from "../../util/http";
export default {
  name: "guessList",
  metaInfo() {
    return {
      title: "竞猜榜_猎鹰直播",
    };
  },
  data() {
    return {};
  },
  beforeCreate() {
    document.querySelector("body").setAttribute("style", "background-color:#90d481");
  },
  beforeDestroy() {
    document.querySelector("body").removeAttribute("style");
  },
  methods: {},
};
</script>

<style lang="scss" scoped>
.body_content {
  clear: both;
  width: 100%;
  min-width: 14rem;
  min-height: 100%;
  box-sizing: border-box;
  margin-top: 0.6rem;
  background: url("./img/guess_banner.png") no-repeat top center;
  background-size: 100%;

  .body_center {
    clear: both;
    width: 14rem;
    height: auto;
    overflow: hidden;
    box-sizing: border-box;
    margin: 0 auto;
    padding-top: 5rem;
    padding-bottom: 1rem;

    .panel_title {
      clear: both;
      width: 2.5rem;
      height: 0.5rem;
      overflow: hidden;
      background-color: #3b8805;
      border-radius: 0.3rem;
      box-sizing: border-box;
      border: 0.08rem solid #86cf38;
      margin: 0 auto;
      padding: 2px 0.1rem;
      position: relative;
      z-index: 5;

      dt {
        float: left;
        width: 0.3rem;
        height: 0.32rem;
        padding-top: 1px;
        img {
          display: block;
          height: 100%;
        }
      }
      dd {
        float: left;
        width: calc(100% - 0.6rem);
        height: 100%;
        line-height: 0.3rem;
        overflow: hidden;
        font-size: 0.22rem;
        font-weight: 500;
        text-align: center;
        background-image: linear-gradient(to bottom, #fff, #e6ffd9);
        -webkit-background-clip: text;
        color: transparent;
      }
    }
    .guess_role {
      clear: both;
      width: 100%;
      line-height: 0.22rem;
      overflow: hidden;
      background: #faf4b8;
      box-shadow: inset 0px 0px 6px #e8d83d;
      border-radius: 0.2rem;
      box-sizing: border-box;
      padding: 0.5rem;
      padding-right: 0.25rem;
      position: relative;
      top: -0.25rem;
      font-size: 0.16rem;
      color: #287223;
    }

    .prize_products {
      clear: both;
      width: 100%;
      line-height: 0.22rem;
      overflow: hidden;
      background: #73a966;
      box-shadow: inset 0px 0px 6px #368937;
      border-radius: 0.2rem;
      box-sizing: border-box;
      padding: 0.5rem;
      padding-right: 0;
      position: relative;
      top: -0.25rem;

      li {
        float: left;
        width: 4.2rem;
        height: 1.2rem;
        overflow: hidden;
        background-image: url("./img/icon_prize_medal.png");
        background-repeat: no-repeat;
        background-position: top right;
        background-size: 1rem;
        background-color: #4c8641;
        box-sizing: border-box;
        border-radius: 0.1rem;
        padding: 0.18rem 0.24rem;
        margin-right: 0.2rem;
        margin-bottom: 0.2rem;

        .cover {
          float: left;
          width: 0.83rem;
          height: 0.83rem;
          overflow: hidden;
          background-color: #fff;
          border-radius: 0.13rem;
          box-sizing: border-box;
          padding: 0.08rem;
          img {
            display: block;
            width: 100%;
          }
        }

        .product_title {
          float: left;
          width: calc(100% - 1.4rem);
          height: 100%;
          overflow: hidden;
          box-sizing: border-box;
          padding: 0px 0.1rem;

          dt {
            clear: both;
            width: 100%;
            height: 0.25rem;
            overflow: hidden;
            font-size: 0.18rem;
            font-weight: 600;
            color: #fff;
          }

          dd {
            clear: both;
            width: 100%;
            height: 0.4rem;
            line-height: 0.2rem;
            overflow: hidden;
            font-size: 0.14rem;
            color: #fff;
            display: -webkit-box;
            -webkit-line-clamp: 2;
            -webkit-box-orient: vertical;
            text-overflow: ellipsis;
          }
        }
      }
    }
    .join_step {
      clear: both;
      width: 100%;
      overflow: hidden;
      background: #368937;
      box-shadow: inset 0px 0px 6px #21621d;
      border-radius: 0.2rem;
      box-sizing: border-box;
      padding: 0.5rem;
      padding-right: 0;
      position: relative;
      top: -0.25rem;

      li {
        float: left;
        width: 30%;
        height: 100%;
        overflow: hidden;
        margin-right: 0.5rem;

        &:nth-child(3) {
          margin-right: 0;
        }

        .step_text {
          clear: both;
          width: 100%;
          height: 0.28rem;
          line-height: 0.28rem;
          overflow: hidden;
          background: url("./img/bg_step.png") no-repeat top left;
          background-size: auto 100%;
          box-sizing: border-box;
          padding-left: 0.1rem;
          margin-left: 0.05rem;
          font-size: 0.16rem;
          color: #3b8805;
        }

        p {
          clear: both;
          width: 100%;
          height: 0.5rem;
          line-height: 0.5rem;
          overflow: hidden;
          box-sizing: border-box;
          margin-left: 0.05rem;
          font-size: 0.16rem;
          color: #fff;

          img {
            display: inline-block;
            width: 0.5rem;
            vertical-align: middle;
          }
        }
        .step_img {
          clear: both;
          width: 100%;
          overflow: hidden;
          img {
            display: block;
            width: 100%;
          }
        }
      }
    }
  }
}
</style>